export default __webpack_public_path__ + "static/media/SIFA_FR_EPILOGUE03.fff5ae51.mp3";